module.exports = new __parcel__URL__("virtuousbonding.c3f8c8c6.png").toString();